import React from "react";
import "../components/componentstyle/whychooseUs.css";
// import bestServiceImg from "../assets/best-service-img.jpg";
// import reputationImg from "../assets/reputation-img.jpg";
// import saftyImg from "../assets/security-img.jpg";
import Testimonial from "./Testimonial";
// import { FaCaretRight } from "react-icons/fa";

const WhyChooseUs = () => {
  return (
    <section className="choose-section">
      <div className="container-fluid">
        <div className="row g-0">
          {/* Left Column */}
          <div className="col-lg-6 p-5 choose-section-info">
            <h2 className="section-title">
              <span className="highlight-box">Why</span> Choose Us
            </h2>
            <p className="section-subtext d-none">
              We at Solid export believe that Indian culture and our
              extraordinary flavors should reach every side of the world. Solid
              export is one of the chief export company for the transportation
              of Indian cereals and pulses.
            </p>
            {/* 
            <div className="feature-item">
              <FaHandsHelping className="feature-icon" />
              <img src={bestServiceImg} alt="" className="feature-icon" />
              <div>
                <h5 className="feature-title">Best Services</h5>
                <p className="section-subtext">
                  We provide our import & export services throughout the world
                  with an exceptional job that speaks clearly in our work.
                </p>
              </div>
            </div>

            <div className="feature-item">
              <img src={reputationImg} alt="" className="feature-icon" />
              <div>
                <h5 className="feature-title">Reputation</h5>
                <p className="section-subtext">
                  We are in the market for around 5 years and have made a
                  reputation with our devotional working ethics and standards.
                </p>
              </div>
            </div>

            <div className="feature-item">
              <img src={saftyImg} alt="" className="feature-icon" />
              <div>
                <h5 className="feature-title">Safety & Security</h5>
                <p className="section-subtext">
                  We understand the safety and security you deserve during the
                  supplement of the products, and we take all the essential
                  measures to maintain so.
                </p>
              </div>
            </div> */}

            {/* <div className="feature-item pt-2">
              <p>
                <FaCaretRight className="feature-icon" />
              </p>
              <div>
                <p className="section-subtext">
                  Based in the Trade-Rich City of Surat
                </p>
              </div>
            </div>
            <div className="feature-item">
              <p>
                <FaCaretRight className="feature-icon" />
              </p>
              <div>
                <p className="section-subtext">
                  Certified, Quality-Assured Products
                </p>
              </div>
            </div>
            <div className="feature-item">
              <p>
                <FaCaretRight className="feature-icon" />
              </p>
              <div>
                <p className="section-subtext">
                  Dedicated Customer Service Team
                </p>
              </div>
            </div>
            <div className="feature-item">
              <p>
                <FaCaretRight className="feature-icon" />
              </p>
              <div>
                <p className="section-subtext">
                  Transparent Communication & Documentation
                </p>
              </div>
            </div>
            <div className="feature-item">
              <p>
                <FaCaretRight className="feature-icon" />
              </p>
              <div>
                <p className="section-subtext">Customized Export Solutions</p>
              </div>
            </div> */}

            <div className="whyChoose-txt">
              <ul className="whyChoose-ul">
                <li>Based in the Trade-Rich City of Surat</li>
                <li>Certified, Quality-Assured Products</li>
                <li>Dedicated Customer Service Team</li>
                <li>Transparent Communication & Documentation</li>
                <li>Customized Export Solutions</li>
              </ul>
            </div>
          </div>

          {/* Right Column */}
          {/* <div
            id="carouselExample"
            class="carousel slide col-lg-6 bg-image position-relative"
          >
            <div class="carousel-inner overlay-content text-white p-4 text-center">
              <div class="carousel-item active">
                <div className="imagediv">
                  <img
                    src={profile1}
                    class="d-block testimonial-img rounded-circle"
                    alt="..."
                  />
                </div>
                <p className="testimonial-text mt-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor finibus risus. Vivamus quis aliquet nibh.
                  Nunc vitae felis nunc. Nam scelerisque maximus tempor. Proin
                  sed euismod tellus. Nunc sodales, quam et porttitor accumsan,
                  lectus dolor laoreet dolor, a scelerisque.
                </p>
                <h6 className="mt-3 testimonial-name">WILLIAMSON - WEB DEVELOPER</h6>
                <FaQuoteLeft  size={30} color="#00aaff" className="mt-3" />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div> */}
          <Testimonial />
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
